import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import iconSearchNX from '../../assets/images/ic-search.svg';
import iconBusEireann from '../../assets/images/bus-eireann/search-btn.svg';
import iconSearchDublinExpress from '../../assets/images/dublin-express/ic-search.svg';
import iconSearchMegabus from '../../assets/images/megabus/search-button.svg';
import iconSearchHinkley from '../../assets/images/hinkley/search-button.svg';
import iconSearchNXbus from '../../assets/images/nxbus/search-btn.svg';
import iconSearchWoodbury from '../../assets/images/woodbury/search-btn.svg';

import { getName } from '../../actions/ServicesAction';
import { THEME } from '../../configs/global';

const getSearchIcon = (name) => {
  switch (name) {
    case 'NX':
      return iconSearchNX;
    case 'Bus-Eireann':
      return iconBusEireann;
    case 'Dublin-Express':
      return iconSearchDublinExpress;
    case 'Megabus':
      return iconSearchMegabus;
    case 'NX-Bus':
      return iconSearchNXbus;
    case 'Hinkley':
      return iconSearchHinkley;
    case 'Woodbury':
      return iconSearchWoodbury;
    default:
      return iconSearchNX;
  }
};

export const getStopName = (name) => {
  if (name) {
    if (name.indexOf(':') !== -1)
      return [
        name.substring(0, name.indexOf(':') + 1),
        name.substring(name.indexOf(':') + 1),
      ];

    if (name.length > 35) {
      // eslint-disable-next-line
      let positions = [];
      for (let i = 0; i < name.length; i++) {
        if (name[i].match(/[a-z]/) != null) {
          positions.push(i);
        }
      }
      const index = positions[0] - 1;
      return [
        name.substring(0, index).replace('(', ''),
        name.substring(index).replace('(', ''),
      ];
    }
    return [name];
  }
  return ['Unknow'];
};

const RecentSearch = ({ search, recentSearch }) => (
  <div onClick={recentSearch(search)} className="recent-search">
    <div
      className={`recent-search__item ${
        search.to_stops_metadata && search.to_stops_metadata.length ? 'recent-search__item--border' : ''
      }`}
    >
      {search.routes && search.routes[0].metadata ? (
        <Fragment>
          <span>Service</span>
          <p>{search.routes[0].metadata.route_id}</p>
          <p></p>
        </Fragment>
      ) : (
        <Fragment>
          <span>From</span>
          {THEME.NAME === 'Megabus' ? (
            <Fragment>
              <p>
                {getStopName(getName(search, 0))[0]}
                <span>
                  {getStopName(getName(search, 0)).length > 1
                    ? getStopName(getName(search, 0))[1]
                    : ''}
                </span>
              </p>
            </Fragment>
          ) : (
            <Fragment>
              <p>{getStopName(search.stops[0].metadata.public_facing_name)[0]}</p>
              <p>
                {getStopName(search.stops[0].metadata.public_facing_name).length > 1
                  ? getStopName(search.stops[0].metadata.public_facing_name)[1]
                  : ''}
              </p>
            </Fragment>
          )}
        </Fragment>
      )}
      <img
        src={getSearchIcon(THEME.NAME)}
        className={`recent-search__image ${
          search.to_stops_metadata && search.to_stops_metadata.length ? '' : 'recent-search__image--single'
        }`}
        alt="search"
      />
    </div>
    {search.to_stops_metadata && search.to_stops_metadata.length && (
      <div className="recent-search__item">
        <span>To</span>
        {THEME.NAME === 'Megabus' ? (
          <Fragment>
            <p>
              {getStopName(getName(search, 1))[0]}
              <span>
                {getStopName(getName(search, 1)).length > 1
                  ? getStopName(getName(search, 1))[1]
                  : ''}
              </span>
            </p>
          </Fragment>
        ) : (
          <Fragment>
            <p>{getStopName(search.to_stops_metadata[0].public_facing_name)[0]}</p>
            <p>
              {getStopName(search.to_stops_metadata[0].public_facing_name).length > 1
                ? getStopName(search.to_stops_metadata[0].public_facing_name)[1]
                : ''}
            </p>
          </Fragment>
        )}
        <p></p>
      </div>
    )}
  </div>
);

RecentSearch.propTypes = {
  search: PropTypes.object.isRequired,
  recentSearch: PropTypes.func.isRequired,
};

export default RecentSearch;



// WEBPACK FOOTER //
// ./src/containers/search-service/RecentSearch.js